export const DISH_STATUS = {
  PENDING: "PENDING",
  DENIED: "DENIED",
  APPROVED: "APPROVED",
  DISABLED: "DISABLED",
};


